import axios from "axios";
export const fetchBadges = async uuid => {
    if (uuid) {
        try {
            const response = await axios.get(process.env.VUE_APP_URL + "badge?user_uuid=" + uuid, {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            //  console.log(response.data)
            return response.data;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    } else {
        try {
            const response = await axios.get(process.env.VUE_APP_URL + "badge", {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            //  console.log(response.data)
            return response.data;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    }
};
